import types from './types';
import paySimpleService from 'src/services/paySimple/paySimpleService';

import { IPaySimpleError } from './reducers';

const getCheckoutToken = (): any => (dispatch: any) => {
  dispatch(setIsPending(true));
  dispatch(setError());
  paySimpleService
    .getCheckoutToken()
    .then(res => {
      dispatch(setJwtToken(res.JwtToken));
      dispatch(setExpirationDate(res.Expiration));
      dispatch(setUrl(res.url));
      dispatch(setIsPending(false));
    })
    .catch((e: any) => {
      dispatch(setIsPending(false));
      dispatch(
        setError({
          hasFailed: true,
          message: e.message
        })
      );
    });
};

const setJwtToken = (jwtToken: string) => {
  return { type: types.SET_PAYSIMPLE_CHECKOUT_TOKEN, payload: jwtToken };
};

const setExpirationDate = (expiration: string) => {
  return { type: types.SET_PAYSIMPLE_CHECKOUT_EXPIRATION, payload: expiration };
};

const setUrl = (url: string) => {
  return { type: types.SET_PAYSIMPLE_CHECKOUT_URL, payload: url };
};

const setIsPending = (isPending: boolean) => {
  return { type: types.SET_PAYSIMPLE_CHECKOUT_IS_PENDING, payload: isPending };
};

const setError = (error?: IPaySimpleError) => {
  return {
    type: types.SET_PAYSIMPLE_CHECKOUT_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

export default {
  getCheckoutToken
};
